import React from 'react';
import AlertActions from '../reflux/AlertActions';
import AuthStore from '../reflux/stores/AuthStore';
import AuthActions from '../reflux/AuthActions';
import Card, {CardHeader, CardText, CardActions} from 'material-ui/Card';
import env from '../env';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import List, {ListItem} from 'material-ui/List';
import Link from 'react-router/lib/Link';
import Settings from 'material-ui/svg-icons/action/settings';
import User from 'material-ui/svg-icons/action/account-circle';
import Credit from 'material-ui/svg-icons/action/credit-card';
import Add from 'material-ui/svg-icons/content/add';

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            totals: {retivas: 0, proveedores: 0, correlativos: {}, suscripcion: {servicio:{}}}
        };

        this.handleAuth = this.handleAuth.bind(this);
    }


    componentWillMount() {
        AuthActions.getTotals();
        AlertActions.configureAppBar('retenlo.com.ve', null);
    }

    componentDidMount() {
        this.unsubscribe = AuthStore.listen(this.handleAuth);
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    handleAuth(e, data) {
        if (e === 'getTotals') {
            this.setState({totals: data});
        }
    }

    render() {
        const headerStyle = {
            background: '#ddd'
        };
        return (
            <div style={{marginTop:35}}>
                <div className="row">
                    

                    <div className="col-sm-6 col-xs-12 card">
                        <Card>
                            <CardHeader title="Mi Cuenta" style={headerStyle}>
                            </CardHeader>
                            <CardText style={{padding:0}}>
                                <List>
                                    <ListItem 
                                        primaryText="Plan Actual" 
                                        secondaryText={this.state.totals.suscripcion.servicio.descripcion}/>

                                    <ListItem 
                                        primaryText="Vencimiento" 
                                        secondaryText={this.state.totals.suscripcion.days_left+' días'}/>
                                </List>

                            </CardText>

                            <CardActions>
                            <div style={{marginRight:0}}>
                                <div className="row">
                                    <div className="col-sm-6  col-xs-12" style={{margin:'auto', marginTop:5}}>
                                        <Link to="/user/" style={{textDecoration:'none'}}>
                                            <RaisedButton style={{width:'100%'}} label="Mis Datos" icon={<User/>} primary={true}/>
                                        </Link>
                                    </div>

                                    <div className="col-sm-6  col-xs-12" style={{margin:'auto', marginTop:5}}>
                                        <Link to="/user/suscripcion" style={{textDecoration:'none'}}>
                                            <RaisedButton style={{width:'100%'}} label="Suscripción" icon={<Credit/>} primary={true}/>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            </CardActions>
                        </Card>
                    </div>

                    <div className="col-xs-12 col-sm-6 card">
                        <Card>
                            <CardHeader title="Resumen de Operaciones" style={headerStyle}>
                            </CardHeader>
                            <CardText style={{padding:0}}>
                                <List>
                                    <ListItem
                                        disableTouchRipple={true} 
                                        primaryText="Comprobantes de Ret. de I.V.A."
                                        secondaryText={this.state.totals.retivas}
                                        rightIconButton={
                                            <Link to="retiva/create">
                                                <IconButton><Add /></IconButton>
                                            </Link>} />
                                    <ListItem
                                        disableTouchRipple={true} 
                                        primaryText="Comprobantes de Ret. de I.S.L.R."
                                        secondaryText="Proximamente..." />



                                </List>

                            </CardText>

                            <CardActions>
                            <div style={{marginRight:0}}>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12  col-xs-12">
                                        <Link to="retiva/create">
                                        <RaisedButton style={{width:'100%'}} label="Nueva Ret. de I.V.A." primary={true}/>
                                        </Link>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-xs-12">
                                         <Link to="retiva">
                                         <FlatButton style={{width:'100%'}} label="Ver Todas" primary={true}/>
                                         </Link>
                                    </div>
                                </div>
                                </div>

                            </CardActions>
                        </Card>
                    </div>

                </div>

            </div>
            );
    }
}



/** WEBPACK FOOTER **
 ** ./app-react/pages/Index.jsx
 **/